/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateActivityItem} from '../api'

export const useMutationCreateOrUpdateActivityItem = createReactQueryMutationHook('createOrUpdateActivityItem', createOrUpdateActivityItem)
